import { isFromProvider, isFromStore } from '../../../graphql/utils/transaction-types'
import { Transaction, TransactionEntity } from '../../../graphql'

function render( from: TransactionEntity, { transactionType }: Transaction ) {
	if ( transactionType ) {
		if ( isFromStore( transactionType ) || isFromProvider( transactionType ) ) {
			return from.name
		}
	}
	return ''
}

export default {
	field: 'from',
	name: 'From',
	render,
}
